import { CustomerListPage } from '@app/modules/CustomerList/CustomerListPage'

import { getClientsPath } from './paths'

export const routes = [
  {
    path: getClientsPath(),
    component: CustomerListPage,
    exact: true
  }
]
